// "moderator-<sessionId>-<id>" (e.g. "moderator-23806-274") from the moderator user-details
// API ({ data: { id } }): this moderator's Ably clientId and chat user id. null without an id
// (0 counts as none - it must not become a shared "moderator-23806-0").
export function buildModeratorClientId(sessionId, userDetails) {
  const id = userDetails?.data?.id;
  if (!sessionId || id == null || id === "" || String(id) === "0") return null;
  return `moderator-${sessionId}-${id}`;
}
